import React from 'react';
import { components } from 'react-select';
import { useIntl } from '@pass-frontend/common/i18n';
import { RdsButton, RdsLink } from '@pass-frontend/rally-energon-react';

export const Menu = (props: any) => {
  const { t } = useIntl();

  const handleApplyChanges = () => {
    // close the menu after clicking on Apply button
    props.selectProps.onMenuClose();
  };

  // clear selections after clicking on Clear button
  const handleClearSelections = () => {
    props.clearValue();
    typeof props.selectProps?.onClear === 'function' &&
      props.selectProps?.onClear();
  };

  return (
    <components.Menu
      {...props}
      data-testid="select-menu"
      className="has-rds-p-24"
    >
      {props.children}
      <div className="is-display-flex">
        <RdsButton type="button" variant="primary" onClick={handleApplyChanges}>
          {t('common.selectDropdown.apply')}
        </RdsButton>

        {props.selectProps.isMulti && (
          <RdsLink
            variant="heading"
            typographySize="sm"
            className="rds-link-ext-inline is-rds-body-2 has-rds-ml-24"
            onClick={handleClearSelections}
          >
            {t('common.selectDropdown.clear')}
          </RdsLink>
        )}
      </div>
    </components.Menu>
  );
};
